import React from "react";
import { Label, Table, Header, Button } from "semantic-ui-react";

import { GetUser } from "../../services/auth";
import TemplateMain from "../../components/TemplateMain";



const Material: React.FC = () => {
    const { role } = GetUser();    
    const content = (  
        <>
        <Header icon="book" as="h1" content="Material de Apoio" dividing/>     
        <Table            
            selectable 
            color="pink">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width="2">Tipo</Table.HeaderCell>
                        <Table.HeaderCell>Arquivo</Table.HeaderCell>
                        <Table.HeaderCell width="2"></Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
            <Table.Body>
            {(role === "Admin" || role === "Representante")
            &&
                <Table.Row>                    
                    <Table.Cell  width="1">
                    <Label
                            ribbon
                            icon="pdf file"
                            color="red"
                            content="PDF"
                        />
                    </Table.Cell>
                    <Table.Cell>
                        Como cadastrar kit para um revendedor.
                    </Table.Cell>
                    <Table.Cell textAlign="center" width="2">
                        <Button
                            href={require("../../assets/Material/cadastro_de_kit.pdf")}                            
                            target="_blank"
                            color="blue"
                            icon="download"                 
                            />
                    </Table.Cell>             
                </Table.Row>}                    
            </Table.Body>
        </Table>
        </>
    )
    return (
        <TemplateMain
            loading={false}
            content={content}
        />
    )
}
export default Material;
